import React from "react";
import QuizHome from "../QuizWithLeaderboard/Quizhome";

const StorePage = () => {
  return (
    <div>
      <h1>Store Page</h1>
      <QuizHome />
      <ev-engagement group-name="store" />
    </div>
  );
};

export { StorePage };
